"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import useCapacitor from "@/hooks/useCapacitor";
import { ManifoldClaimStatus, ManifoldPhase, useMemesManifoldClaim } from "@/hooks/useManifoldClaim";
import { useEffect, useState } from "react";
import MintCountdownBox from "./MintCountdownBox";
export default function MemePageMintCountdown(props) {
  const $ = _c(14);
  const [isError, setIsError] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsError(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const manifoldClaim = useMemesManifoldClaim(props.nft_id, t0);
  let t1;
  let t2;
  if ($[1] !== manifoldClaim) {
    t1 = () => {
      if (manifoldClaim && !manifoldClaim.isError) {
        setIsError(false);
      }
    };
    t2 = [manifoldClaim];
    $[1] = manifoldClaim;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const {
    isIos
  } = useCapacitor();
  const {
    country
  } = useCookieConsent();
  let t3;
  if ($[4] !== manifoldClaim) {
    t3 = () => {
      if (!manifoldClaim) {
        return;
      }
      const phaseName = manifoldClaim.phase === ManifoldPhase.ALLOWLIST && manifoldClaim.memePhase ? manifoldClaim.memePhase.name : manifoldClaim.phase;
      const title = manifoldClaim.status === ManifoldClaimStatus.UPCOMING ? `${phaseName} Starts In` : `${phaseName} Ends In`;
      const date = manifoldClaim.status === ManifoldClaimStatus.UPCOMING ? manifoldClaim.startDate : manifoldClaim.endDate;
      const showAllowlistInfo = manifoldClaim.phase === ManifoldPhase.ALLOWLIST;
      const isFinalized = manifoldClaim.isFinalized;
      const isSoldOut = manifoldClaim.isSoldOut;
      const isEnded = manifoldClaim.status === ManifoldClaimStatus.ENDED;
      return {
        title,
        date,
        showAllowlistInfo,
        isFinalized,
        isEnded,
        isSoldOut
      };
    };
    $[4] = manifoldClaim;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const getMintInfo = t3;
  const hideMintBtn = props.hide_mint_btn || isIos && country !== "US";
  let t4;
  if ($[6] !== getMintInfo) {
    t4 = getMintInfo();
    $[6] = getMintInfo;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      href: "/the-memes/mint",
      target: "_self"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== hideMintBtn || $[10] !== isError || $[11] !== props.hide_mint_btn || $[12] !== t4) {
    t6 = <MintCountdownBox mintInfo={t4} linkInfo={t5} hideMintBtn={hideMintBtn} small={props.hide_mint_btn} isError={isError} />;
    $[9] = hideMintBtn;
    $[10] = isError;
    $[11] = props.hide_mint_btn;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}